export default __webpack_public_path__ + "static/media/fcgroup.9b48aac3.svg";